// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Q91j","colCheckbox":"styles_colCheckbox__10Cec"};